import React from "react";
interface FeatureItem {
  icon: string;
  title: string;
  text: string;
}
interface FeaturesProps {
  data?: FeatureItem[];
}
export const Features: React.FC<FeaturesProps> = ({ data }) => (
  <section id="solucao" className="relative py-24">
    <div className="absolute inset-0 -z-10 bg-white/70" />
    <div className="mx-auto max-w-6xl px-6 lg:px-8">
      <div className="mx-auto max-w-2xl text-center">
        <p className="text-xs font-semibold uppercase tracking-[0.3em] text-blue-600">
          Uma operação que avança
        </p>
        <h2 className="mt-3 text-3xl font-semibold text-slate-900 sm:text-4xl">
          Mais agilidade para o contato. Mais controle para sua equipe.
        </h2>
        <p className="mt-4 text-slate-600">
          A Sengia reduz tarefas repetitivas sem afastar as pessoas dos casos
          que realmente precisam de atenção humana.
        </p>
      </div>
      <div className="mt-12 grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-4">
        {data?.map((d, i) => (
          <div
            key={i}
            className="group rounded-2xl border border-slate-200/70 bg-white/90 p-6 text-left shadow-sm transition hover:-translate-y-1 hover:shadow-soft animate-fade-up"
            style={{ animationDelay: `${i * 80}ms` }}
          >
            <div className="mb-4 inline-flex h-12 w-12 items-center justify-center rounded-xl bg-blue-100 text-blue-600 transition group-hover:bg-blue-600 group-hover:text-white">
              <i className={`${d.icon} !text-2xl`}></i>
            </div>
            <h3 className="text-lg font-semibold text-slate-900 mb-2">
              {d.title}
            </h3>
            <p className="text-sm leading-relaxed text-slate-600">{d.text}</p>
          </div>
        )) ?? "Loading..."}
      </div>
    </div>
  </section>
);
